import React, { useState } from 'react';
import { Button, Modal } from '@mantine/core';
import { Plus } from 'tabler-icons-react';
import { PackageUnitForm } from './PackageUnitForm';
import { useTranslation } from 'react-i18next';

export function PackageUnitCreateDialog() {
  const { t } = useTranslation();
  const [opened, setOpened] = useState(false);

  return (
    <>
      <Button
        color="green"
        size="md"
        variant="light"
        leftIcon={<Plus />}
        onClick={() => setOpened(true)}
      >
        {t('PackageUnitCreateDialog.Title')}
      </Button>
      <Modal
        opened={opened}
        onClose={() => setOpened(false)}
        size="lg"
        title={t('ResourceCreateDialog.Title')}
      >
        <PackageUnitForm create={true} onFinish={() => setOpened(false)} />
      </Modal>
    </>
  );
}
